import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Card } from 'antd'

import type { Compartment } from '../../../../api/useOrders/responses'
import { LidCodeIcon } from './LidCodeIcon'
import type { RouteLogResponse } from '../../../../api/useFreight/useOrderRouteLog'

interface TransportInfoProps {
  driverName: string
  compartments?: Compartment[]
  trailerConfig?: string
  routeLogData?: RouteLogResponse
}

export function TransportInfo({ driverName, routeLogData }: TransportInfoProps) {
  // Use data from routeLogData.trailer_info if available
  const trailerInfoCompartments = routeLogData?.trailer_info?.compartments || []
  const trailerInfoConfig = routeLogData?.trailer_info?.trailer_config || ''

  return (
    <Card size='small' style={{ width: '100%' }}>
      <Horizontal justifyContent='space-between' verticalCenter>
        <Vertical gap={4}>
          <Texto appearance='hint'>Transported By</Texto>
          <Texto category='p2'>{driverName}</Texto>
        </Vertical>

        <Vertical gap={4} alignItems='flex-end'>
          <Horizontal gap={4} verticalCenter>
            <Texto>{trailerInfoConfig || 'N/A'}</Texto>
          </Horizontal>
          {trailerInfoCompartments.length > 0 && (
            <Horizontal borderRadius={2} gap={2}>
              {trailerInfoCompartments.map((compartment, index) => (
                <LidCodeIcon
                  key={compartment.product_name}
                  productName={compartment.product_name || ''}
                  lidUrl={compartment.lid_code_url || ''}
                />
              ))}
            </Horizontal>
          )}
        </Vertical>
      </Horizontal>
    </Card>
  )
}
